import { KeepInTouchFields, KeepInTouchProps } from '../types/subscriptionBox.types';
import { CheckboxField, LinkField, StringField, TComponentParamsGeneral, THeadingTag, TSocialLinkProps } from '../../../types/types';

export class KeepInTouchModel {
  private readonly fields: null | KeepInTouchFields;
  private readonly params?: TComponentParamsGeneral;

  constructor(props: KeepInTouchProps) {
    this.fields = props?.fields || null;
    this.params = props?.params;
  }

  get title(): StringField | undefined {
    return this.fields?.title;
  }

  get content(): StringField | undefined {
    return this.fields?.content;
  }

  get textboxPlaceholderText(): StringField | undefined {
    return this.fields?.textboxPlaceholderText;
  }

  get showForm(): CheckboxField | undefined {
    return this.fields?.showForm;
  }

  get submitButtonLink(): LinkField | undefined {
    return this.fields?.submitButtonLink;
  }

  get socialMediaTitle(): StringField | undefined {
    return this.fields?.socialMediaTitle;
  }

  get socialMediaLinks(): TSocialLinkProps[] {
    return this.fields?.items || [];
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h2';
  }
}
